export enum AttachmentType {
    PASSPORT = 'PASSPORT',
    SELFIE = 'SELFIE',
    ADDRESS = 'ADDRESS',
    DOCUMENT = 'DOCUMENT'
}

export enum AttachmentTypeID {
    PASSPORT = 1,
    SELFIE = 2,
    ADDRESS = 3,
    DOCUMENT = 4
}

export interface AttachmentItem {
    id: string,
    name: string,
    attachmentTypeId: AttachmentTypeID,
    attachmentSubTypeId?: number
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/attachment.ts